import insertNodeAfter from "./insertNodeAfter";

export default function wrapNode(element, wrapper) {
    insertNodeAfter(element, wrapper);
    wrapper.appendChild(element);
}
